import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    update: (state, action) => {
      return { ...action.payload };
    },
    clear: (state) => {
      state = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { update, clear } = userSlice.actions;

export default userSlice.reducer;
